import React from "react";
import PageHero from "../components/PageHero";
import WhyProspera from "../components/WhyProspera";
import HowWeWork from "../components/HowWeWork";
import Services from "../components/Services";
import Contact from "../components/Contact";
import { IMAGES } from "../config/siteConfig";

export default function Employers() {
  return (
    <>
      <PageHero
        label="Employers"
        title="Looking for people who can"
        highlight="make a difference?"
        subtitle="Partner with a recruitment team that understands your business, your sector, and the professionals who will help you grow."
        image={IMAGES.employers}
      />
      <WhyProspera />
      <Services />
      <HowWeWork />
      <Contact />
    </>
  );
}
